import { render, staticRenderFns } from "./reportnewForms.vue?vue&type=template&id=7f74da64&scoped=true&"
import script from "./reportnewForms.vue?vue&type=script&lang=js&"
export * from "./reportnewForms.vue?vue&type=script&lang=js&"
import style0 from "./reportnewForms.vue?vue&type=style&index=0&id=7f74da64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74da64",
  null
  
)

component.options.__file = "reportnewForms.vue"
export default component.exports